// The Default state for the db
import { State } from "./types";



export const defaultState: State = {
  phoneNumber: "1800 954 754",
  locationState: {
    shortName: "QLD",
    longName: "Queensland",
    fetched: false,
    fetching: false,
    error: false,
  },
  pipaAccepted: false,
  modal: false,
};

export default defaultState;
